mutation signOutMutation {
    signOut
  }